import type { AxiosPromise, AxiosResponse } from "axios";
import { route } from "../../shim/jsbridge";
import {
  IApiResponse,
  ISecondaryLicensingId,
  ITiCloudConfig,
  IServerTime
} from "./@types/licensing";
import { AxiosApiWrapper } from "../../services/api/AxiosApiWrapper";

class Api extends AxiosApiWrapper {
  getLocalLicense = (): AxiosPromise<any> => this.get(route("api-licensing"));
  getSecondaryLicensingId = (): AxiosPromise<ISecondaryLicensingId> =>
    this.get(route("api-cluster-secondary-licensing-id"));

  generateMachineId = (licenseId: string): AxiosPromise<void> =>
    this.post(route("api-generate-machine-id"), { licenseId });

  uploadLicenseFile = (licenseFile: File): AxiosPromise<IApiResponse> => {
    const formData = new FormData();

    formData.append("file", licenseFile);

    return this.put(route("api-upload-license"), formData, {
      headers: { "Content-Type": "multipart/form-data" }
    });
  };

  configureTiCloud = (formValues: ITiCloudConfig): AxiosPromise<IApiResponse> =>
    this.post(route("api-account-configuration"), formValues);

  getTiCloudConfig = (): Promise<AxiosResponse<ITiCloudConfig>> =>
    this.get(route("api-account-configuration"));

  getServerTime = (): Promise<AxiosResponse<IServerTime>> =>
    this.get(route("api-server-time"));
}

export default new Api();
